import type { RouteUnitRosterYouthRank } from '@modules/roster-lite/routes.types';
import { ROUTE_ADVANCEMENT } from '@shared/duck/actions';

export const ROUTE_ROSTER_LITE = 'ROUTE_ROSTER_LITE';

/** Unit roster for youth/parents, sourced from the SBLUnitRosterLiteReport */
export const ROUTE_UNIT_ROSTER = 'ROUTE_UNIT_ROSTER';

/** Youth advancement profile reached from the unit roster */
export const ROUTE_UNIT_ROSTER_YOUTH = 'ROUTE_UNIT_ROSTER_YOUTH';

/** A youth's rank requirements/details page, reached from the profile's ranks card */
export const ROUTE_UNIT_ROSTER_YOUTH_RANK = 'ROUTE_UNIT_ROSTER_YOUTH_RANK';

/** Route action for a youth's rank requirements page under the unit roster */
export const goToUnitRosterYouthRank = (params: RouteUnitRosterYouthRank) => ({
  type: ROUTE_UNIT_ROSTER_YOUTH_RANK,
  payload: { ...params },
});

/**
 * Builds the roster route action for an org: the lite roster for lite-only users,
 * otherwise the full roster.
 */
export const rosterRouteForOrg = (hasLiteAccess: boolean, orgGuid: string) =>
  hasLiteAccess
    ? { type: ROUTE_ROSTER_LITE, payload: { orgGuid } }
    : { type: ROUTE_ADVANCEMENT };
